import React, { useState, useEffect, useRef } from 'react';

const EditableFeedback = ({ initialContent, onSave }) => {
  const editorRef = useRef(null);
  const [content, setContent] = useState(initialContent || '');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setContent(initialContent || '');
  }, [initialContent]);

  const handleBold = () => {
    document.execCommand('bold', false, null);
  };

  const handleItalic = () => {
    document.execCommand('italic', false, null);
  };

  const handleUnderline = () => {
    document.execCommand('underline', false, null);
  };

  const handleColor = (color) => {
    document.execCommand('foreColor', false, color);
  };

  const handleSave = () => {
    const updatedContent = editorRef.current.innerHTML.trim();

    if (!updatedContent || updatedContent === '<br>') {
      alert('Please enter feedback before saving!');
      return;
    }

    onSave(updatedContent); // ✅ Pass the updated content to parent
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div style={styles.editorContainer}>
      <div style={styles.toolbar}>
        <button onClick={handleBold} style={styles.toolbarButton}><b>B</b></button>
        <button onClick={handleItalic} style={styles.toolbarButton}><i>I</i></button>
        <button onClick={handleUnderline} style={styles.toolbarButton}><u>U</u></button>
        <input
          type="color"
          onChange={(e) => handleColor(e.target.value)}
          style={styles.colorPicker}
        />
        <button onClick={handleSave} style={styles.saveButton}>Save Feedback</button>
        {saved && (<span style={styles.checkmark} role="img" aria-label="Saved successfully">✅</span>)}
      </div>

      <div
        ref={editorRef}
        contentEditable
        dangerouslySetInnerHTML={{ __html: content }}
        style={styles.editorBox}
      />
    </div>
  );
};

export default EditableFeedback;

const styles = {
  editorContainer: {
    border: '1px solid #ccc',
    borderRadius: '8px',
    marginBottom: '10px',
  },
  toolbar: {
    display: 'flex',
    gap: '10px',
    padding: '8px',
    borderBottom: '1px solid #eee',
    backgroundColor: '#f4f4f4',
    alignItems: 'center',
  },
  toolbarButton: {
    padding: '4px 8px',
    cursor: 'pointer',
  },
  colorPicker: {
    marginLeft: 'auto',
    cursor: 'pointer',
  },
  saveButton: {
    padding: '6px 12px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginLeft: '10px',
  },
  checkmark: {
    marginLeft: '10px',
    color: 'green',
    fontSize: '18px',
  },
  editorBox: {
    minHeight: '100px',
    padding: '10px',
    outline: 'none',
  },
};
